import SettingLayout from 'components/SettingLayout';
import { AccountContainer } from 'components/Settings/Accounts';
import { AdminContainer } from 'components/Settings/Admin';
import MyProfile from 'components/Settings/MyProfile/MyProfileContainer';
import Marketplace from 'components/Settings/MarketPlace/Marketplace';
import BillingAndUsage from 'components/Settings/BillingAndUsage/BillingAndUsage';
import WorkspacesPage from 'components/Settings/workspace/WorkspacesPage';
import WorkspacesSettings from 'components/Settings/workspace/SingleWorkSpace/WorkspacesSettingsContainer';
import { Routes, Route, Navigate } from 'react-router-dom';
import Connections from 'components/Settings/Connections';

function SettingsRouts() {
  return (
    <SettingLayout>
      <Routes>
        <Route path='/my-profile' element={<MyProfile />} />
        <Route path='/account' element={<AccountContainer />} />
        <Route path='/Workspaces' element={<WorkspacesPage />} />
        <Route path='/workspaces/:id' element={<WorkspacesSettings />} />
        <Route path='/connections' element={<Connections />} />
        <Route path='/billing-and-usage' element={<BillingAndUsage />} />
        <Route path='/creator' element={<Marketplace />} />
        <Route path='/admin' element={<AdminContainer />} />
        <Route path='*' element={<Navigate to='/settings/my-profile' />} />
      </Routes>
    </SettingLayout>
  );
}

export default SettingsRouts;
